import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';

import { ContactPluginService } from './contact-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { Person } from '../../shared/models/index';
import { maxPhoneLengthValidator } from '../../utils/maxPhoneLength.directive';

@Component({
    selector: 'contact-edit',
    templateUrl: './contact-edit.component.html',
    standalone: false
})
export class ContactEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  public people: Person[];
  public technicien: Person;
  public regionalServiceManager: Person;
  public processing = false;

  editForm: UntypedFormGroup;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: ContactPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service
      .updateContact(
        this.inspectionId,
        this.pluginId,
        model.technicienId,
        model.regionalServiceManagerName,
        model.regionalServiceManagerTel,
        model.regionalServiceManagerEmail,
        model.localOfficeTel
      )
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.initPeople();
      this.initTechnicien();
      this.cdRef.detectChanges();
    });
  }

  initPeople() {
    this.service.getPeople().subscribe((people) => {
      this.people = people.sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        } else if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });
  }

  initTechnicien() {
    const technicienId = this.editForm.controls['technicienId'].value;
    if (technicienId) {
      this.service.getPerson(technicienId).subscribe((person) => {
        this.technicien = person;
      });
    }
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      technicienId: new UntypedFormControl(this.plugin.config.TechnicienId, Validators.required),
      regionalServiceManagerName: new UntypedFormControl(this.plugin.config.RegionalServiceManagerName),
      regionalServiceManagerTel: new UntypedFormControl(this.plugin.config.RegionalServiceManagerTel, [
        Validators.pattern(/^([+]?\d{1,2}[-| \s]?)?(\d{1,4}[-| ]?){1,4}?(\d{1,4}[-| ]?)\d{1,4}$/),
        Validators.minLength(10),
        maxPhoneLengthValidator(21)
      ]),
      regionalServiceManagerEmail: new UntypedFormControl(this.plugin.config.RegionalServiceManagerEmail),
      localOfficeTel: new UntypedFormControl(this.plugin.config.LocalOfficeTel, [
        Validators.pattern(/^([+]?\d{1,2}[-| \s]?)?(\d{1,4}[-| ]?){1,4}?(\d{1,4}[-| ]?)\d{1,4}$/),
        Validators.minLength(10),
        maxPhoneLengthValidator(21)
      ])
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  selectTypesMenu(e: any) {}

  onTypesMenuClose() {}

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin() {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
